/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Camera_Settings_Base_Url_HintInputs */

const vi_grower_camera_settings_base_url_hint = /** @type {(inputs: Grower_Camera_Settings_Base_Url_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt buộc HTTPS. Đây là gốc chung cho mọi đường dẫn camera.`)
};

/**

* @param {Grower_Camera_Settings_Base_Url_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_camera_settings_base_url_hint = /** @type {((inputs?: Grower_Camera_Settings_Base_Url_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Camera_Settings_Base_Url_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_camera_settings_base_url_hint(inputs)
});